/**
 * Feature Flags
 * 
 * Centralized feature toggles for the Turn Platform.
 * Toggle features on/off without removing code.
 * 
 * To re-enable a feature, set it to true.
 */

export const FEATURES = Object.freeze({
  /**
   * Turn Art illustration generation via Gemini.
   * When false: generation is not triggered, Turn Art tab is hidden,
   * but all code paths remain intact for re-enablement.
   */
  TURN_ART_GENERATION: false,

  /**
   * Addison Tutor voice teaching feature.
   * When false: tutor routes are disabled, ElevenLabs agent is not accessed.
   */
  TUTOR: false,

  /**
   * Skill-based word progression system for the Turn Color curriculum.
   * When false: skill-based filtering and progression tracking is disabled.
   */
  SKILL_PROGRESSION: false,

  /**
   * Stripe billing (subscriptions, checkout, customer portal, usage metering).
   * When false: billing UI is hidden, Stripe functions are not called.
   * Business model shifting from recurring to module-based pricing.
   */
  BILLING: false,

  /**
   * Class scheduling (slots, bookings, calendar sync, availability).
   * When false: scheduling UI is hidden, cron jobs should be disabled manually.
   */
  SCHEDULING: false,

  /**
   * Consonant practice cards (QR-scanned physical cards, /consonant-practice route).
   * When false: route is disabled, nav links hidden, admin QR/video-gen gated.
   */
  CONSONANT_PRACTICE: false,
} as const);
